// components/PersonalData.js
import React, { useState, useEffect } from 'react';
import { TextField, ListItem, ListItemText } from '@mui/material';
import {
  BaseLabel,
  RowContainer,
  RadioGroup,
  RadioInput,
  RadioLabel,
  Input,
  InputHalf,
  AutoComplete,
} from '../../../styles/styleUtils';

import { getClientes } from '../../api';

function PersonalData({ formData, onInputChange}) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetchFormas();
  }, []);
  const fetchFormas = async () => {
    const result = await getClientes();
    setOptions(result);
  };

  return (
    <div>
      <RowContainer>
        <BaseLabel htmlFor="cpf">CPF</BaseLabel>
        <InputHalf disabled type="text" id="cpf" name="cpf" value={formData.cliente.cpf} onChange={onInputChange} />
      </RowContainer>
      <RowContainer>
        <BaseLabel htmlFor="nascimento">Data de Nascimento</BaseLabel>
        <InputHalf disabled type="date" id="nascimento" name="nascimento" value={formData.cliente?.nascimento ? new Date(formData.cliente?.nascimento).toISOString().split('T')[0] : ''} onChange={onInputChange} />
      </RowContainer>
      <RowContainer>
        <BaseLabel htmlFor="telefone">Telefone</BaseLabel>
        <InputHalf disabled type="tel" id="telefone" name="telefone" value={formData.cliente.telefone} onChange={onInputChange} />
      </RowContainer>
      <RowContainer>
        <BaseLabel htmlFor="email">Email</BaseLabel>
        <InputHalf disabled type="tel" id="email" name="email" value={formData.cliente.email} onChange={onInputChange} />
      </RowContainer>
      <RowContainer>
        <BaseLabel>Sexo</BaseLabel>
        <RowContainer>
          <RadioGroup>
            <RadioInput
              type="radio"
              id="masculino"
              name="sexo"
              value="masculino"
              checked={formData.cliente.sexo === 'masculino'}
              onChange={onInputChange}
              disabled
            />
            <RadioLabel htmlFor="masculino">Masculino</RadioLabel>
          </RadioGroup>
          <RadioGroup>
            <RadioInput
              type="radio"
              id="feminino"
              name="sexo"
              value="feminino"
              checked={formData.cliente.sexo === 'feminino'}
              onChange={onInputChange}
              disabled
            />
            <RadioLabel htmlFor="feminino">Feminino</RadioLabel>
          </RadioGroup>
        </RowContainer>
      </RowContainer>
    </div>
  );
}

export default PersonalData;
